export default function FallbackComponent() {
  return (
    <>
      <p>Leider ist etwas schief gelaufen :(</p>
      <p>Something went wrong :(</p>
      <p>Désolé, une erreur s'est produite :(</p>
    </>
  );
}
